import { render, staticRenderFns } from "./AppointmentsUniqueCheck.vue?vue&type=template&id=180bf3e3"
import script from "./AppointmentsUniqueCheck.vue?vue&type=script&lang=js"
export * from "./AppointmentsUniqueCheck.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsUniqueCheck.vue?vue&type=style&index=0&id=180bf3e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports